import makeApi from '@/common/API';

const api = makeApi(() => window.env.REMOTE_BROWSER.API_URL);

export default api;
